module.exports = __webpack_public_path__ + "img/Snow.850be404.png";